module.exports = __webpack_public_path__ + "img/2015013.e4dc6fe5.svg";